import { SSEClient } from "@infrastructure/clients/sse/clients/base/sse.client";
import { BASE_URL } from "@infrastructure/clients/http/config";

export class EventsSSEClient extends SSEClient {
  baseUrl = BASE_URL;

  subscribeToEvents(onMessage: (data: any) => void, onError?: (error: Error) => void): () => void {
    return this.subscribe("/api/events/stream", {
      onMessage,
      onError,
      reconnect: true,
      reconnectDelay: 1000,
      maxReconnectAttempts: 5,
    });
  }
}

